import { Component, Inject } from '@angular/core';
import { PagerService } from '../../services/shared/pager.service';
import { EmailTemplateService } from '../../services/EmailTemplate/EmailTemplate.service';
import { EmailTemplate } from '../../models/EmailTemplate/EmailTemplate-model';
import { UtilitiesService } from '../../services/shared/utilities.service';
import { NotificationService } from '../../services/notification/notification.service';
import { Role } from '../../models/shared/role.model';
import { ToastsManager } from 'ng2-toastr';
import { RoleService } from '../../services/role/role.service';
import { RolePermissionService } from '../../services/role/role-permission.service';
import { Router } from '@angular/router';
@Component({
  selector: 'app-EmailTemplate-list',
  templateUrl: './EmailTemplate-list.component.html',
  styleUrls: ['./EmailTemplate-list.component.css']
})
/** EmailTemplate-List component*/
export class EmailTemplateListComponent {
  public EmailTemplateList: EmailTemplate[];
  public emailTemplate = new EmailTemplate();
  public Roles: Role[];
  emailTemplateisActive: string;
  type: any;
  // pager object
  pager: any = {};
  searchQuery: string;
  searchKeyword: string;
  types: string;
  trigger: string;
  isActive: string;
  role: string;
  pageSize: number;
  // paged items
  pagedItems: any[];
  filteredItems: any[];
  public rowsOnPage: number;
  public arrRowsPerPage: number[];
  public isDeleteAllowed: boolean = false;
  public isEditAllowed: boolean = false;
  public isCreateAllowed: boolean = false;
  /** coupons-list ctor */
  constructor(private readonly EmailTemplatesService: EmailTemplateService,
    private readonly notificationService: NotificationService,
    private readonly utilitiesService: UtilitiesService,
    public toastr: ToastsManager,
    private readonly roleservices: RoleService,
    private readonly pagerService: PagerService, private readonly router: Router, private readonly rolePermissionService: RolePermissionService) {
    this.rolePermissionService.GetRolePermissions("emailtemplate").subscribe(
      data => {
        if (data != null) {

          var create = data.filter(function (element) {
            return (element.action == "create");
          });
          var list = data.filter(function (element) {
            return (element.action == "list");
          });

          var deletePermission = data.filter(function (element) {
            return (element.action == "delete");
          });

          var edit = data.filter(function (element) {
            return (element.action == "edit");
          });

          if (create.length > 0)
            this.isCreateAllowed = true;

          if (edit.length > 0)
            this.isEditAllowed = true;

          if (deletePermission.length > 0)
            this.isDeleteAllowed = true;
          if (list.length > 0) {
          this.types = "";
          this.trigger = "";
          this.isActive = "";
          this.role = "";
          //this.emailTemplate.emailTemplateTriggerTo = "";
          //this.emailTemplateisActive = "";
          //this.emailTemplate.emailTemplateType = "";
          this.getEmailTemplates();
          this.pageSize = 10;
          this.getEmailTemplates();
          this.GetRowsPerPageList();
          this.GetTriggerValues();
            this.GetCustomerTypes();
          }
          else {
            this.router.navigate(["/"]);
          }
        }
        else {
          this.router.navigate(["/"]);
        }
      }
    )
  }


  deleteEmailTemplate(id) {

    var ans = confirm("Are you sure to delete this email template?");
    if (ans) {
      this.toastr.success('Email Template has been Deleted.', 'Success');
      if (this.EmailTemplatesService.deleteEmailTemplate(id)) {
        this.getEmailTemplates();
      }

     // setTimeout(this.getEmailTemplates(), 1000);
    }
  }
  getEmailTemplates() {

    this.EmailTemplatesService.getEmailTemplate().subscribe(
      data => {
        this.EmailTemplateList = data
        this.filteredItems = data;
      }

    )
  }
  GetTriggerValues() {
    this.EmailTemplatesService.getEmailTemplateTriggerTo().subscribe(
      data => {
        
        this.emailTemplate.TriggerTo = data;
       

      }
    )
  }
  GetCustomerTypes() {
    this.roleservices.GetActiveRoles().subscribe(
      data => {
        
        this.Roles = data;
      }
    )
  }
  setPage(page: number) {

    // get pager object from service
    this.pager = this.pagerService.getPager(this.EmailTemplateList.length, page, this.pageSize);

    // get current page of items
    this.pagedItems = this.EmailTemplateList.slice(this.pager.startIndex, this.pager.endIndex + 1);
  }
  // Populate the row per page list
  GetRowsPerPageList() {
    this.arrRowsPerPage = this.utilitiesService.GetRowsPerPageList();
    this.rowsOnPage = this.arrRowsPerPage[0];
  }
  // Search the Grid
  onSearch(searchText: string) {
    
    if (searchText != "") {
      this.filteredItems = this.utilitiesService.GetSearchedResult(this.EmailTemplateList, searchText);

    } else {
      this.filteredItems = this.EmailTemplateList;
    }
  }
  OnFilterChange() {
   
    //types: string;
    //trigger: string;
    //isActive: string;
    //role: string;
    this.filteredItems = this.EmailTemplateList;
    if (this.searchKeyword != "" && this.searchKeyword != null) {
      this.filteredItems = this.utilitiesService.GetSearchedResult(this.filteredItems, this.searchKeyword);
    }

    if (this.types != "" && this.types != null) {
      this.filteredItems = this.filteredItems.filter(s => s.emailTemplateType == this.types);

    }
    if (this.trigger != "" && this.trigger != null) {
      this.filteredItems = this.filteredItems.filter(s => s.emailTemplateTriggerTo == this.trigger);

    }
    if (this.isActive != "" && this.isActive != null) {
      this.filteredItems = this.filteredItems.filter(s => s.emailTemplateisActive.toString() == this.isActive);

    }
    if (this.role != "" && this.role != null) {
     // this.filteredItems = this.filteredItems.filter(s => s.emailTemplateCommaSeperatedRoles.replace(',', '') == this.role);
      this.filteredItems =this.utilitiesService.GetSearchedResult(this.filteredItems, this.role);
    }
    //if (this.StatusId > 0) {
    //  this.filteredItems = this.filteredItems.filter(s => s.statusID == this.StatusId);

    //}


  }
 
}



// WEBPACK FOOTER //
// ./src/app/EmailTemplate/EmailTemplate-list/EmailTemplate-list.component.ts